// mutation-types.js
export const FETCH_BADGELIST = 'FETCH_BADGELIST';